// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { AuthUser } from "@/lib/auth/types";

type SecondFactorUser = Pick<AuthUser, "realm" | "hasMfa" | "hasPasskey" | "permissions">;

/**
 * Should this user be nudged to set up MFA or a passkey? Only local (password) accounts that can mutate
 * anything in the back office and have neither factor. SSO accounts are exempt — their IdP owns the
 * second factor, and they can't register TOTP or passkeys here anyway.
 */
export function needsSecondFactor(user: SecondFactorUser | null): boolean {
  if (user?.realm !== "local") return false;
  if (user.hasMfa || user.hasPasskey) return false;
  return user.permissions.some((p) => p.startsWith("backoffice:") && p.endsWith(":edit"));
}
